import type { IComplications, IPad, TOperation } from 'neuro-schemas/epilepsySurgicalTreatment';
import * as React from 'react';

interface IData {
  d?: TOperation | IPad | IComplications;
  fm?: (id: string) => string;
}

export const DataContext: React.Context<IData> = React.createContext({});
